import { blueGreyMui, greyMui, rydeColors } from "@ryde/theme";

import { PassengerSexEnum } from "../../enums";

const PASSENGER_SEX_COLORS = {
  selected: {
    [PassengerSexEnum.Male]: rydeColors.passengerMaleSelected,
    [PassengerSexEnum.Female]: rydeColors.passengerFemaleSelected,
  },
  unselected: {
    [PassengerSexEnum.Male]: rydeColors.passengerMaleUnselected,
    [PassengerSexEnum.Female]: rydeColors.passengerFemaleUnselected,
  },
} as const;

export const getPassengerSexColor = ({
  sex,
  isSelected,
  isGenderDistinctionEnabled,
}: {
  sex: PassengerSexEnum | undefined;
  isSelected: boolean;
  isGenderDistinctionEnabled: boolean;
}): string => {
  if (!isGenderDistinctionEnabled || !sex) {
    return "";
  }
  const state = isSelected ? "selected" : "unselected";
  return PASSENGER_SEX_COLORS[state][sex];
};

export const getPassengerNameColor = ({
  isGreyed,
  isScopeRestricted,
}: {
  isGreyed?: boolean;
  isScopeRestricted?: boolean;
}): string => {
  if (isGreyed) {
    return greyMui._500;
  }

  if (isScopeRestricted) {
    return greyMui._500;
  }

  return blueGreyMui._900;
};
